<template>
    <conversation-nav class="vx-justify-between">
        <div class="vx-flex vx-gap-2 vx-items-center">
            <vx-button size="sm" color="secondary" @click="emit('unloadContact')">
                <font-awesome-icon :icon="faArrowLeft"></font-awesome-icon>
            </vx-button>
            <div class="vx-flex vx-gap-2 vx-items-center">
                <font-awesome-icon :icon="faUser" class="vx-text-slate-300"></font-awesome-icon>
                <div class="vx-inline-flex vx-flex-wrap">
                    <span class="vx-text-base vx-text-slate-100 vx-font-extrabold vx-self-center vx-mr-1">{{ contactTitle }}</span>
                    <span v-if="contact.first_name || contact.last_name"
                    class="vx-text-base vx-text-slate-300 vx-self-center">{{ formatPhoneNumber(contact.phone) }}</span>
                </div>
            </div>
        </div>
        <vx-button size="sm" color="secondary" @click="emit('open:contactDetails')">
            Edit
            <font-awesome-icon :icon="faFilePen" inverse />
        </vx-button>
    </conversation-nav>
</template>
<script setup>
import { computed } from 'vue';
import { formatPhoneNumber } from '~/components/filters';
import { VxButton } from '@voxie/frontend-components';
import { faArrowLeft, faFilePen, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ConversationNav from '~/components/messages/browser-extension/components/ConversationNav.vue'
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';

const { contact } = useContactDetails();

const emit = defineEmits(['open:contactDetails', 'unloadContact']);

const contactTitle = computed(() => {
    if (contact.value.first_name && contact.value.last_name) {
        return `${contact.value.first_name} ${contact.value.last_name}`
    } else if (
        contact.value.first_name ||
        contact.value.last_name
    ) {
        return `${contact.value.first_name || contact.value.last_name}`
    }

    return formatPhoneNumber(contact.value.phone)
});
</script>
